export class RagProductDetail {
  constructor(element) {
    this.ragFooter = element.querySelector('.js-rag-footer');
    this.ragField = element.querySelector('.js-rag-input');
    this.ragFieldCode = element.querySelector('.js-rag-inputCode');
    this.ragFieldProductCode = element.querySelector('.js-rag-inputProductCode');
    this.ragLikes = element.querySelectorAll('.js-rag-buttonLike');
    this.ragResponse = element.querySelector('.js-rag-response');
    this.ragSubmit = element.querySelector('.js-rag-buttonSubmit');
    this.ragClear = element.querySelector('.js-rag-buttonClear');
    this.ragLoading = element.querySelector('.js-rag-loading');
    this.ragNoResponse = element.querySelector('.js-rag-noResponse');
  }
  initRag() {
    this.computeState();
    if (this.ragField && this.ragFieldProductCode && this.ragResponse) {
      this.ragField.addEventListener('input', () => {
        this.computeState();
      });
      this.ragLikes.forEach(likeButton => {
        likeButton.addEventListener('click', e => {
          this.ragLikes.forEach(btn => {
            btn.classList.add('mc-button--bordered-neutral');
          });
          const ragLikeValue = e.currentTarget.getAttribute('data-rag-like');
          const clickedButton = e.currentTarget;
          if (ragLikeValue && this.ragFieldCode.value.length > 0) {
            fetch(`/services/rag-productdetail/like`, {
              method: 'POST',
              body: JSON.stringify({
                code: this.ragFieldCode.value,
                like: ragLikeValue
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(() => {
              clickedButton.classList.remove('mc-button--bordered-neutral');
            }).catch(error => {
              console.error('Error liking:', error);
            });
          }
        });
      });
      this.ragField.closest('form').addEventListener('submit', event => {
        event.preventDefault();
        if (this.ragField.value.length === 0) {
          return;
        }
        const inputValue = encodeURIComponent(this.ragField.value);
        const inputProductCodeValue = this.ragFieldProductCode.value;
        this.fetchNDJSON(`/services/rag-productdetail?query=${inputValue}&productCode=${inputProductCodeValue}`);
      });
    }
    if (this.ragClear) {
      this.ragClear.addEventListener('click', () => {
        this.clearAll();
      });
    }
  }
  computeState(forceClear = false) {
    const hasEmptyText = !(this.ragField.value.length > 0);
    const isDisabled = forceClear || hasEmptyText;
    this.ragSubmit.disabled = isDisabled;
    this.ragClear.classList.toggle('kl-hidden', hasEmptyText);
    if (isDisabled) {
      this.ragResponse.innerHTML = '';
      this.ragFieldCode.value = '';
      this.ragFooter.classList.add('kl-hidden');
      this.ragLikes.forEach(likeButton => {
        likeButton.classList.add('mc-button--bordered-neutral');
      });
    }
  }
  clearAll() {
    this.ragField.value = '';
    this.computeState();
  }
  async appendToDOM(data, answerDiv) {
    await new Promise(resolve => setTimeout(resolve, 300));
    if (data.code) {
      this.ragFieldCode.value = data.code;
    }
    if (data.success === false) {
      const noResponse = this.ragNoResponse.cloneNode(true);
      noResponse.classList.remove('kl-hidden');
      answerDiv.innerHTML = '';
      answerDiv.appendChild(noResponse);
      this.previousText = '';
      this.endAnswer();
      return;
    }
    if (!data.answer) return;
    const newWords = data.answer.slice(this.previousText.length).split(' ');
    let index = 0;
    for (const word of newWords) {
      await new Promise(resolve => setTimeout(resolve, 50 + Math.random() * 100));
      answerDiv.textContent += word;
      if (index < newWords.length - 1) {
        answerDiv.textContent += ' ';
      }
      index++;
    }
    this.previousText = data.answer;
  }
  endAnswer() {
    this.ragFooter.classList.remove('kl-hidden');
  }
  async fetchNDJSON(url) {
    this.ragLoading.classList.remove('kl-hidden');
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/x-ndjson'
      }
    });
    this.previousText = '';
    this.computeState(true);
    const responseDiv = document.createElement('div');
    responseDiv.classList.add('m-ragProductDetailResponse');
    const answerDiv = document.createElement('div');
    answerDiv.classList.add('m-ragProductDetailResponse__answer');
    responseDiv.appendChild(answerDiv);
    this.ragResponse.appendChild(responseDiv);
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    while (true) {
      this.ragLoading.classList.add('kl-hidden');
      const {
        done,
        value
      } = await reader.read();
      if (done) {
        this.endAnswer();
        break;
      }
      buffer += decoder.decode(value, {
        stream: true
      });
      let lines = buffer.split('\n');
      buffer = lines.pop();
      for (const line of lines) {
        if (line.trim() === '') continue;
        try {
          const json = JSON.parse(line);
          await this.appendToDOM(json, answerDiv);
        } catch (err) {
          console.error('RAG invalid:', line, err);
        }
      }
    }
    if (buffer.trim()) {
      try {
        const json = JSON.parse(buffer);
        await this.appendToDOM(json, answerDiv);
      } catch (err) {
        console.error('Last line RAG invalid:', buffer, err);
      }
    }
  }
}
export default RagProductDetail;